module.exports = require('jadelet').exec(["menu-item",{},[["hr",{},[]]]]);